import { useState } from "react";
import { C } from "../../styles/theme";

export default function FAQ({ items }) {
  const [open, setOpen] = useState(null);
  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      {items.map((f, i) => (
        <div key={i} style={{ border: `1px solid ${C.border}`, borderRadius: 11, marginBottom: 9, overflow: "hidden", background: "#fff", boxShadow: "0 1px 6px rgba(26,60,110,.05)" }}>
          <button onClick={() => setOpen(open === i ? null : i)} style={{ width: "100%", padding: "16px 18px", background: "none", border: "none", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", textAlign: "left", gap: 12 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: C.blue, flex: 1 }}>{f.q}</span>
            <span style={{ fontSize: 20, color: C.orange, flexShrink: 0, transition: "transform .25s", transform: open === i ? "rotate(45deg)" : "rotate(0deg)" }}>+</span>
          </button>
          {open === i && (
            <div style={{ padding: "0 18px 16px", fontSize: 13.5, color: C.gray, lineHeight: 1.75, borderTop: `1px solid ${C.border}` }}>
              <div style={{ paddingTop: 12 }}>{f.a}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
